<template>
  <div id="contact">
    <div class="container">
      <ul class="contact_card">
        <li class="contact_card_item">
          <h6>咨询电话</h6>
          <h3>029-88605419</h3>
          <div class="card_icon">
            <img src="../../assets/images/contact_1.png" alt />
          </div>
        </li>
        <li class="contact_card_item">
          <h6>Contact us</h6>
          <i></i>
          <h1>联系我们</h1>
          <p>陕西远达智能科技有限公司</p>
        </li>
        <li class="contact_card_item">
          <h6>联系邮箱</h6>
          <h3>yd@yuandacloud.com</h3>
          <div class="card_icon">
            <img src="../../assets/images/contact_6.png" alt />
          </div>
        </li>
        <li class="contact_card_item">
          <h6>公司邮编</h6>
          <h3>710075</h3>
          <div class="card_icon">
            <img src="../../assets/images/contact_5.png" alt />
          </div>
        </li>
        <li class="contact_card_item">
          <h6>公司网址</h6>
          <h3>http://www .yuandacloud.com</h3>
          <div class="card_icon">
            <img src="../../assets/images/contact_4.png" alt />
          </div>
        </li>
        <li class="contact_card_item">
          <h6>公司地址</h6>
          <h3>
            陕西省西安市高新区科技二路72号
            西安软件园天泽大厦2楼
          </h3>
          <div class="card_icon">
            <img src="../../assets/images/contact_3.png" alt />
          </div>
        </li>
      </ul>
    </div>
    <div class="map_img">
      <div class="location">
        <img src="../../assets/images/contact_map2.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
#contact {
  .container {
    width: 1200px;
    margin: 200px auto 120px;
    .contact_card {
      display: flex;
      flex-wrap: wrap;

      .contact_card_item {
        width: 400px;
        height: 251px;
        position: relative;

        padding: 40px 0 0 30px;

        .card_icon {
          margin-bottom: 19px;
        }
        h6 {
          font-size: 14px;
          line-height: 24px;
          font-weight: 400;
        }
        h3 {
          font-size: 20px;
          line-height: 24px;
          margin: 20px 0 0 0;
          font-weight: 400;
          width: 304px;
          height: 100px;
        }
      }
      li:nth-child(2) {
        background: url("../../assets/images/contact_2.png");
        color: rgba(255, 255, 255, 1);
        h6 {
          font-size: 14px;
          text-transform: uppercase;
          line-height: 20px;
          color: rgba(255, 255, 255, 1);
        }
        i {
          display: block;
          width: 40px;
          height: 4px;
          background: rgba(255, 255, 255, 1);
          margin: 8px 0;
        }
        h1 {
          font-size: 36px;
          font-weight: 500;
          line-height: 50px;
          margin-bottom: 30px;
        }
        p {
          font-size: 20px;
          font-weight: 500;
          line-height: 24px;
        }
      }
      li:nth-child(1)::after,
      li:nth-child(3)::after {
        content: "";
        display: block;
        height: 1px;
        width: 340px;
        background-color: #000000;
      }
      li:nth-child(4),
      li:nth-child(5) {
        border-right: 1px solid #000000;
      }
      li:nth-child(4),
      li:nth-child(5),
      li:nth-child(6) {
        margin-top: 25px;
      }
    }
  }
  .map_img {
    background: url("../../assets/images/contact_map.png") no-repeat;
    height: 861px;
    background-position: center;
    position: relative;
    width: 1200px;
    margin: 0 auto;
    border: 1px solid rgb(129, 127, 127);
    .location {
      position: absolute;
      top: 303px;
      left: 51%;
    }
  }
}
</style>